import React from 'react';
import TextField from 'material-ui/TextField'

export const renderTextField = ({
                             input,
                             label,
                             meta: {touched, error},
                             ...custom
                         }) => (
    <TextField
        hintText={label}
        floatingLabelText={label}
        errorText={touched && error}
        {...input}
        {...custom}

    />

)


// WEBPACK FOOTER //
// ./src/components/fields/TextField.js